import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Download,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Zap,
} from "lucide-react";
import heroImage from "../assets/campin100.jpg";
import iconTrading from "../assets/setting.png";
import iconHandshake from "../assets/handshake.png";
import { FaWhatsapp, FaAndroid, FaApple, FaWindows, FaGooglePlay } from "react-icons/fa";
import Header from "./Header";

const Campaign = () => {
  const { influencerName } = useParams();
  const [data, setData] = useState(null);
  const [showDownloads, setShowDownloads] = useState(false);
const [loading, setLoading] = useState(true);
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching data for influencer:", influencerName);
        const response = await fetch(
          "https://docs.google.com/spreadsheets/d/e/2PACX-1vQUARCZsjIVdxddig5gFM0jzLmro0C-UMTqHCY9A3Vr1evgZZUJxfj8hYvfk2ao42Xh6ajvRSjdt5yw/pub?output=csv"
        );
        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }
        const text = await response.text();
        const rows = text.split("\n").map((row) => row.split(","));
        const headers = rows[0];
        // const data = rows.slice(1).map((row) =>
        //   headers.reduce((acc, header, index) => {
        //     acc[header.trim()] = row[index]?.trim();
        //     return acc;
        //   }, {})
        // );
        console.log("Fetched data:", data);

      const parsedData = rows.slice(1).map((row) =>
        headers.reduce((acc, header, index) => {
          acc[header.trim()] = row[index]?.trim();
          return acc;
        }, {})
      );
        console.log("Fetched data:", data);
        const influencerData = parsedData.find(
          (entry) => entry.influencer_key?.toLowerCase() === influencerName.toLowerCase()
        );
        console.log("Matched influencer data:", influencerData);
        setData(influencerData || null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setData(null); // Ensure data is null if an error occurs
      }finally {
      setLoading(false); // 🔑 important
    }
    };
 
    fetchData();
  }, [influencerName, data]);
 
  if (loading) {
  return null; // or spinner if you want (but you said no extra UI)
}
 
  if (!data) {
    return (
      <div>
        <h1>Influencer Not Found</h1>
        <p>Please check the URL or contact support for assistance.</p>
      </div>
    );
  }

  return (
    <Wrapper>
      <Header/>
      <HeroImage />

      <Container>
        <Content style={{ marginBottom: 32 }}>
          <PrimaryButton
            href={data.crm_encrypted_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            ACCESS PLATFORM NOW
          </PrimaryButton>
        </Content>

        <CardGrid>
          <FeatureCard
            icon={iconTrading}
            title="Free Demo Trading"
            description="Learn in a risk-free environment"
          />
          <FeatureCard
            icon={iconHandshake}
            title="Practice with 500X Simulated Leverage"
            description="Test high-leverage strategies"
          />
          <FeatureCard
            icon={iconTrading}
            title="Free Demo Trading"
            description="Learn in a risk-free environment"
          />
        </CardGrid>

        <Content>
          <h1>Welcome, {data.name}!</h1>

          <p className="desc">{data.message}</p>

          <p className="highlight">Don't let this opportunity slip away!</p>

          <PrimaryButton
            href={data.crm_encrypted_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            ACCESS PLATFORM NOW
          </PrimaryButton>

          <Info>
            <span>
              <Zap size={14} color="#D4FF00" />
              Registration takes only 10 seconds
            </span>
            <span>No hidden fees or charges</span>
          </Info>
        </Content>

        <SocialRow>
          <SocialIcon
            href="https://www.facebook.com/people/Tredixo-LTD/61582532235948/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook />
          </SocialIcon>
          <SocialIcon
            href="https://x.com/tredixo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Twitter />
          </SocialIcon>
          <SocialIcon
            href="https://www.instagram.com/tredixo_official/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram />
          </SocialIcon>
          <SocialIcon
            href="https://www.youtube.com/@Tredixo_officialYT"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Youtube />
          </SocialIcon>
        </SocialRow>
      </Container>

      <WhatsappFloating>
        <WhatsappInner
          href={`https://wa.me/9517855192?text=Hello Tredixo Team,\nI have reached here through reference: ${influencerName}  \n I would like to open a Real Trading Account.\nPlease help me create my Trading ID.\nThank you. `}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
        </WhatsappInner>
      </WhatsappFloating>

      <DownloadWrapper>
        {showDownloads && (
          <DownloadMenu>
            <DownloadIcon
              href="https://play.google.com/store/apps/details?id=com.tredixo.tredixo&hl=en_I"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* <FaAndroid style={{ color: "#34a853" }} /> */}
              <FaGooglePlay style={{ color: "#34a853" }} />
            </DownloadIcon>
            <DownloadIcon
              href="https://apps.apple.com/jo/app/osense-trader/id6741929487"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaApple style={{ color: "#000" }} />
            </DownloadIcon>
            <DownloadIcon
              href="https://theplatformapi.com/setup/tredixo.exe"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWindows style={{ color: "#0078d7" }} />
            </DownloadIcon>
          </DownloadMenu>
        )}

        <FloatingButton
          bg="#1e90ff"
          onClick={() => setShowDownloads(!showDownloads)}
        >
          <Download />
        </FloatingButton>
      </DownloadWrapper>
    </Wrapper>
  );
};

function FeatureCard({ icon, title, description }) {
  return (
    <Card>
      <IconWrapper>
        <img src={icon} alt={title} />
      </IconWrapper>

      <CardTitle>{title}</CardTitle>
      <p>{description}</p>
    </Card>
  );
}

const IconWrapper = styled.div`

  width: 100px;
  height: 100px;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto 20px;

  img {
  
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
`;
const DownloadWrapper = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;
`;

const DownloadMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 72px;
  gap: 12px;
`;

const DownloadIcon = styled.a`
  width: 52px;
  height: 52px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: transform 0.2s ease;
  text-decoration: none;
  svg {
    font-size: 26px;
    color: #1e90ff;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

const CardTitle = styled.h3`
  font-size: 24px;
  color: #002266;
  font-family: "Red Hat Display", sans-serif;
`;

const Wrapper = styled.div`
  min-height: 100vh;
  background: #003da5;
`;

const HeroImage = styled.div`
  width: 100%;
  min-height: 85vh;
  background-image: url(${heroImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 50px;
  /* Large desktops */
  @media (min-width: 1400px) {
    min-height: 120vh;
  }
  /* Small laptops */
  @media (min-width: 1024px) {
    min-height: 85vh; /* Increased height for laptop screens */
    margin-bottom: 40px;
  }

  /* Standard laptops */
  @media (min-width: 1200px) {
    min-height: 95vh;
  }


  /* Large desktops (1440px) */
  @media (min-width: 1440px) {
    min-height: 88vh;
  }
  @media (min-width: 1500px) {
    min-height: 120vh;
  }

  /* Full HD desktops (1920px) */
  @media (min-width: 1920px) {
    min-height: 95vh;
  }

  /* 2K / 4K / Ultra-wide screens */
  @media (min-width: 2560px) {
    min-height: clamp(95vh, 100vh, 110vh);
  }

  /* Laptops */
  @media (max-width: 1200px) {
    min-height: 90vh;
  }

  /* Tablets */
  @media (max-width: 992px) {
    min-height: 60vh;
  }

  /* Large mobiles */
  @media (max-width: 768px) {
    min-height: 55vh;
    background-position: top center;
  }

  /* Standard mobiles (iPhone XR / Pixel / S8+) */
  @media (max-width: 480px) {
    min-height: 27vh;
    background-position: top center;
  }

  /* Small mobiles (iPhone SE) */
  @media (max-width: 375px) {
    min-height: 27vh;
  }

  /* Very small screens */
  @media (max-width: 320px) {
    min-height: 26vh;
  }
`;

const WhatsappFloating = styled.div`
  position: fixed;
  bottom: 30px;
  left: 30px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const WhatsappInner = styled.a`
  width: 65px;
  height: 70px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: transform 0.2s ease;
  text-decoration: none;
  svg {
    font-size: 48px;
    color: #22c55e;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 60px 20px;
`;

const CardGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  margin-bottom: 80px;
  cursor: pointer;
`;

const Card = styled.div`
  background: white;
  padding: 32px;
  border-radius: 18px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: 0.3s;

  &:hover {
    transform: scale(1.05);
  }

  p {
    font-size: 14px;
    color: #003da5;
  }
`;

const Content = styled.div`
  text-align: center;
  max-width: 700px;
  margin: auto;

  h1 {
    font-size: 42px;
    margin-bottom: 20px;
    font-weight: 700;

    background: linear-gradient(90deg, #ffffff 0%, #ccff66 100%);

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  }

  .desc {
    color: white;
    font-size: 18px;
  }

  .highlight {
    color: #ccff66;
    font-size: 20px;
    font-weight: bold;
    margin: 12px 0 40px;
  }
`;

const PrimaryButton = styled.a`
  display: inline-block;
  text-decoration: none;
  background: #d4ff00;
  color: black;
  padding: 16px 40px;
  border-radius: 50px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  padding: 18px 60px;
  line-height: 1.8;
  &:hover {
    transform: scale(1.05);
    background: #c4ef00;
  }
`;

const Info = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: white;

  span {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 6px;
  }
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 60px;
`;

const SocialIcon = styled.a`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #d4ff00;
  border: none;
  color: #003da5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  &:hover {
    transform: scale(1.1);
  }
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  ${(props) => (props.left ? "left: 30px;" : "right: 30px;")}
  width: 64px;
  height: 64px;
  border-radius: 50%;
  cursor: pointer;
  background: ${(props) => props.bg};
  color: white;
  border: none;

  &:hover {
    background: #26a11b;
  }
`;

export default Campaign;